export default {
  getCurrentLanguage(state) {
    return state.currentLanguage;
  },
  getLanguages(state) {
    return state.language;
  },
};
